import axios, { AxiosResponse } from 'axios'
import * as url from 'url'
import * as path from 'path'

import { Api } from '../../definitions/Api'
import { Key } from '../../definitions/Key'
import ApiMapper from './ApiMapper'
import environment from '../../environments/environment'


export default class ApiService {

  constructor() {
    axios.defaults.baseURL = this.format()
    axios.defaults.headers.common['Authorization'] = `Bearer ${sessionStorage.getItem('token')}`
  }

  /**
   * Format uri with path and parameters
   *
   * @param path
   * @param queryParams
   */
  format(): string {
    return url.format({
      protocol: environment.protocol,
      hostname: environment.host,
      port: environment.port,
      pathname: environment.basePath
    })
  }

  /**
   * Retrieve all APIs information from API Gateway
   */
  public async getApis(): Promise<Api[]> {
    let res: AxiosResponse<any>
    res = await axios.get('/apis')

    const mapper = new ApiMapper(res.data)
    return mapper.format()
  }

  /**
   * Get swagger from an API
   *
   * @param apiId The API ID
   */
  public async getSwagger(apiId: string): Promise<any> {
    return (await axios.get(path.join('/apis', apiId, '/swagger'))).data
  }

  /**
   * Retrieve the API keys from an API for a user
   *
   * @param apiId The API ID
   * @param userId The user ID
   */
  public async getApiKeys(apiId: string, userId: string): Promise<Key> {
    return (await axios.get(path.join('/apis', apiId, '/keys'), {
      params: {
        userId: userId
      }
    })).data
  }

  /**
   * Delete API Key
   *
   * @param apiId The API ID
   * @param keyId The API key ID
   * @param userId The user ID
   */
  public async deleteKey(apiId: string, keyId: string, userId: string): Promise<any> {
    return await axios.delete(path.join('/apis', apiId, 'keys', keyId), {
      params: {
        userId: userId
      }
    })
  }

  /**
   * Create API key
   *
   * @param apiId The API ID
   * @param keyName The key name
   * @param userId The user ID
   */
  public async createKey(apiId: string, keyName: string, userId: string): Promise<any> {
    return await axios.post(path.join('/apis', apiId, 'keys', keyName), null, {
      params: {
        userId: userId
      }
    })
  }

}
